import React, { useState } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import * as valid from 'utils/validators';
import { timezones, findTimezone } from 'utils/timezones';

import Fields from 'ui/form/FieldsForm';
import PaperContainer from 'ui/PaperContainer';
import PageContainer from 'ui/PageContainer';
import ButtonsForm from 'ui/form/ButtonsForm';

import { Shedule } from '../../../consts';
import { getDefaultSchedule } from '../../../schedule';
import { Columns, SynchronizeButton } from '../Components';

const DAY_MINUES = 1440;

const isWeekly = values => Shedule.isWeekly(values.day_of_week);

const validTime = name => values => {
    const value = parseInt(values[name], 10);
    if (value >= 0 && value < DAY_MINUES) {
        return value;
    }
    return [name, 'invalid'];
};

const FORM_VALIDATORS = valid.rules([
    validTime('time'),
    valid.notEmpty('timezone'),
    valid.notEmpty('frequency'),
    valid.conditionCheck(
        isWeekly,
        valid.rules([valid.notEmpty('day_of_week')])
    ),
]);

const validateForm = data => valid.validate(FORM_VALIDATORS, data);

export default function SyncSchedule({ service, config, editable }) {
    const {
        extra: { synchronization_schedule: schedule = {} },
    } = service;
    const { serviceProvider } = config;
    if (schedule.timezone) {
        schedule.timezone = findTimezone(schedule.timezone);
    }
    const [edited, setEdited] = useState(false);
    const [values, setValues] = useState({
        ...getDefaultSchedule(),
        ...schedule,
    });
    const [errors, setErrors] = useState({});
    const [synchronized, setSynchronize] = useState(false);
    const onChange = () => editable && setEdited(true);
    const onCancel = () => setEdited(false);
    const onSave = () => {
        validateForm(values).then(errors => {
            setErrors(errors || {});
            if (!errors) {
                serviceProvider.update(service, { schedule: values });
                setEdited(false);
            }
        });
    };
    const onSynchronize = () => {
        if (!synchronized) {
            setSynchronize(true);
            serviceProvider.synchronize(service);
        }
    };

    const changeFactory = name => value => {
        setValues({ ...values, [name]: value });
    };
    const fieldSelectFactory = (name, label, options, native = false) => (
        <Fields.Row>
            <Fields.Select
                label={label}
                value={values[name]}
                error={errors[name]}
                options={options}
                native={native}
                onChange={changeFactory(name)}
            />
        </Fields.Row>
    );
    const isWeekly = Shedule.isWeekly(values.frequency);

    const body = edited ? (
        <Paper elevation={1}>
            <PaperContainer.Body>
                <Columns>
                    <Typography component="div" color="textSecondary">
                        Synchronization schedule
                    </Typography>
                    <div>
                        {fieldSelectFactory(
                            'time',
                            'Time',
                            prepareTimeOptions()
                        )}
                        {fieldSelectFactory(
                            'timezone',
                            'Timezone',
                            timezones,
                            true
                        )}
                        {fieldSelectFactory(
                            'frequency',
                            'Frequency',
                            Shedule.FREQUENCIES
                        )}
                        {isWeekly &&
                            fieldSelectFactory(
                                'day_of_week',
                                'Day of week',
                                Shedule.DAYS
                            )}
                    </div>
                </Columns>
                <ButtonsForm withLeft>
                    <div>
                        <SynchronizeButton
                            onClick={onSynchronize}
                            sync={synchronized}
                        />
                    </div>
                    <div>
                        <ButtonsForm.BackButton onClick={onCancel} />
                        <ButtonsForm.NextButton label="Save" onClick={onSave} />
                    </div>
                </ButtonsForm>
            </PaperContainer.Body>
        </Paper>
    ) : (
        <ExpansionPanel onChange={onChange} expanded={false}>
            <ExpansionPanelSummary>
                {summaryFormat(values, timezones)}
            </ExpansionPanelSummary>
        </ExpansionPanel>
    );
    return <PageContainer title="Sync schedule">{body}</PageContainer>;
}

function prepareTimeOptions() {
    const buff = {};
    for (let i = 0; i < DAY_MINUES; i += 60) {
        buff[i] = minutesToTime(i);
    }
    return buff;
}

function minutesToTime(num) {
    let hour = Math.floor(num / 60);
    let minutes = num % 60;
    let sufix = 'AM';
    if (hour === 0) {
        hour = 12;
    } else if (hour === 12) {
        sufix = 'PM';
    } else if (hour > 12) {
        hour -= 12;
        sufix = 'PM';
    }
    return `${hour}:${minutes < 10 ? '0' : ''}${minutes} ${sufix}`;
}

function summaryFormat({ time, timezone, frequency, day_of_week }, timezones) {
    const [name, options] = Shedule.isWeekly(frequency)
        ? [day_of_week, Shedule.DAYS]
        : [frequency, Shedule.FREQUENCIES];
    return `${options[name]} at ${minutesToTime(time)} ${timezones[timezone]}`;
}
